import Cookies from 'js-cookie'
export default function AccessToken() {
  let central_token = Cookies.get('centralToken');
  if (central_token) {
    return {token: central_token};
  } else {
    return {token: ''};
  }
}



// WEBPACK FOOTER //
// ./src/services/auth-central.js